import { getApiCall, postFormApiCall, postApiCall } from "./tokenService";
import { VehicleGroupItems } from "../models/vehicleGroup/vehicleGroupItems";
import { VehicleGroupEdit } from "../models/vehicleGroup/vehicleGroupEdit";
import { ApiSuccess, SaveSuccess } from "./baseService";
import { ApiResponse, apiCall } from "./apiClient";
import {VehicleGroupItem} from "../models/vehicleGroup/vehicleGroupItem"

// Calls to EasyOpp.Web Vehiclegroups controller
export const getVehicleGroupItems = (pageSize: number, page: number, filter: string, sortColumn: string, sortOrderIsAsc: boolean): Promise<VehicleGroupItems> => {
    return getApiCall<VehicleGroupItems>("api/vehiclegroup/?page=" + (page || "") + "&pageSize=" + (pageSize || "") +
        "&sortColumn=" + (sortColumn ? encodeURIComponent(sortColumn) : "") + "&sortOrder=" + (sortOrderIsAsc ? "asc" : "desc") +
        "&filter=" + (filter ? encodeURIComponent(filter) : ""), VehicleGroupItems);
};

export const getVehicleGroupEdit = (id: string): Promise<VehicleGroupEdit> => {
    return getApiCall<VehicleGroupEdit>("api/vehiclegroup/edit/?id=" + (id || ""), VehicleGroupEdit);
};

export const saveVehicleGroupEdit = (data: FormData): Promise<SaveSuccess> => {
    return postFormApiCall<SaveSuccess>("api/vehiclegroup/save", data, SaveSuccess);
};

export const removeVehicleGroup = (id: string): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/vehiclegroup/remove/?id=" + (id || ""), ApiSuccess);
};

// Calls to EasyOpp.API Vehiclegroups controller
export const getVehicleGroups = (
    vehicleGroupIds: string[] = [],
    signal?: AbortSignal
): Promise<ApiResponse<VehicleGroupItem[]>> => {
    return apiCall<VehicleGroupItem[]>(
        `vehicleGroups?vehicleGroupIds?
        ${(vehicleGroupIds || [])
            .map((id) => `&vehicleIds=${encodeURIComponent(id)}`)
            .join("")}`,
        "GET",
        null,
        signal
    );
};